import BasicResource from '@/api/resource';

class ActivityLog extends BasicResource {
    constructor () {
        super('audit-logs');
    }
}

export default new ActivityLog;
